// extracted by mini-css-extract-plugin
export default {"fullWidthContainer":"Admin_fullWidthContainer__69Nrf","centeredLoader":"Admin_centeredLoader__fVCOU"};